export enum HcResponseMeaning {
  OK = 'response.meaning.ok',
  NOT_OK = 'response.meaning.not_ok',
  NEED_HELP = 'response.meaning.need_help',
  NOT_UNDERSTOOD = 'response.meaning.not_understood'
}
